export type Result<T = any> = (ValueResult<T> | ErrorResult) & ResultMetadata
export interface ValueResult<T> {
  type: "value",
  value: T,
}
export interface ErrorResult {
  type: "error",
  error: Error,
}
export interface ResultMetadata {
  // TODO: not sure yet how to handle metadata like this
  caseTaken?: number,
}

export function valueOrUndefined<T>(result: Result<T>): T | undefined {
  return result.type === 'value' ? result.value : undefined
}

export function valueOrThrow<T>(result: Result<T>): T {
  if (result.type === 'error') { throw result.error }
  return result.value
}



// WEBPACK FOOTER //
// ./src/types/result.ts